import React from 'react';
import { ContentWithImage } from '../../../utils/types';
import { MarkdownContentSection } from '../../../components/PageSections/MarkdownContent';

export interface DisclaimerSectionContainerProps {
  content: {
    title: string;
    listOfContentWithImages: ContentWithImage[];
  };
}

export const DisclaimerSectionContainer: React.FC<DisclaimerSectionContainerProps> = ({
  content,
}) => {
  const { title, listOfContentWithImages } = content;
  const body =
    listOfContentWithImages[0].description?.childMarkdownRemark.html || '';
  return body && title ? (
    <MarkdownContentSection
      title={title}
      headline=""
      subHeadline=""
      body={body}
    />
  ) : null;
};

export default DisclaimerSectionContainer;
